export class ForecastProcessPayload {

    bizDefKey: string;

    dataId: string;

    startMode: string;

    startUserId: string;
}
